import { createSelector } from "reselect";
import { ListFieldsKeys } from "src/api/config";
import { JustDeletedItem } from "src/modules/modules.type";
import { RootState } from "src/store/rootReducer";

const getJustDeletedItem = (state: RootState, listName: ListFieldsKeys): JustDeletedItem => {
  return state.spitems.justDeleted[listName] || 0;
};

export const selectJustDeletedItem = createSelector([getJustDeletedItem], (id) => {
  return id;
});
